export const GetAllFabricType_REQUEST = "GetAllFabricType_REQUEST";
export const GetAllFabricType_SUCCESS = "GetAllFabricType_SUCCESS";
export const GetAllFabricType_FAIL = "GetAllFabricType_FAIL";

export const AddFabricType_REQUEST = "AddFabricType_REQUEST";
export const AddFabricType_SUCCESS = "AddFabricType_SUCCESS";
export const AddFabricType_FAIL = "AddFabricType_FAIL";


export const UpdateFabricType_REQUEST = "UpdateFabricType_REQUEST";
export const UpdateFabricType_SUCCESS = "UpdateFabricType_SUCCESS";
export const UpdateFabricType_FAIL = "UpdateFabricType_FAIL";

export const GetAllInavctiveFabricType_REQUEST = "GetAllInavctiveFabricType_REQUEST";
export const GetAllInavctiveFabricType_SUCCESS = "GetAllInavctiveFabricType_SUCCESS";
export const GetAllInavctiveFabricType_FAIL = "GetAllInavctiveFabricType_FAIL";


export const GetFabTypePresentage_REQUEST = "GetAllFabricType_REQUEST";
export const GetFabTypePresentage_SUCCESS = "GetAllFabricType_SUCCESS";
export const GetFabTypePresentage_FAIL = "GetFabTypePresentage_FAIL";